import React from "react";
import { useAuth } from './auth/AuthContext';
import { Button } from "@mui/material";

const LogoutButton = () => {
  const { logout } = useAuth();

  return (
    <Button variant="text" color="inherit" size="small" onClick={logout} sx={{ color: 'text.secondary' }}>
      Log Out
    </Button>
  );
};

export default LogoutButton;
